import {
    ApiForm,
    type ApiFormProps,
} from '@/React/Shared/Component/Forms/ApiForm'
import {
    FlashStatusTypeEnum,
    type FlashStatusType,
} from '@/Shared/AutoGenerated/Main'
import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
import { flashMessageStore } from '@/React/Shared/Component/Flash/FlashMessageStore'

export interface FlashApiFormProps extends ApiFormProps {}

export function FlashApiForm({
    disableCatch = true,
    onResponse,
    ...apiFormProps
}: FlashApiFormProps) {
    function handleResponse(
        response: ApiFormResponseType,
        httpStatusCode: number,
    ): void {
        onResponse?.(response, httpStatusCode)

        const flashStatus = getFlashStatus(
            response,
            httpStatusCode,
            disableCatch,
        )

        if (flashStatus !== null) {
            flashMessageStore.display(flashStatus)
        }
    }

    return (
        <ApiForm
            {...apiFormProps}
            disableCatch={disableCatch}
            onResponse={handleResponse}
        />
    )
}

function getFlashStatus(
    response: ApiFormResponseType,
    httpStatusCode: number,
    disableCatch: boolean,
): FlashStatusType | null {
    const message = response.getMessage()

    if (message === null || httpStatusCode === 302 || httpStatusCode === 422) {
        return null
    }

    if (httpStatusCode >= 200 && httpStatusCode < 300) {
        return {
            type: FlashStatusTypeEnum.Success,
            message,
        }
    }

    if (!disableCatch) {
        return null
    }

    return {
        type: FlashStatusTypeEnum.Error,
        message,
    }
}
